/**
 * Store to track client metadata
 *
 * Defaults to the values in core/env/default_client_metadata, but can be overridden via push API (core/api/v1)
 *
 * @module
 */

var actionTypes = require('../constants/action_types');
var DefaultClientMetadata = require('core/env/default_client_metadata');

module.exports = {
  initialize: function() {
    this.__state = {
      name: DefaultClientMetadata.NAME,
      version: DefaultClientMetadata.VERSION,
    };

    this.on(actionTypes.SET_CLIENT_NAME, this.__setName);
    this.on(actionTypes.SET_CLIENT_VERSION, this.__setVersion);
  },

  /**
   * Returns the client name
   * @return {string}
   */
  getClientName: function(): string {
    return this.__state.name;
  },

  /**
   * Returns the client version
   * @return {string}
   */
  getClientVersion: function(): string {
    return this.__state.version;
  },

  /**
   * @param {string} [name]
   * @private
   */
  __setName: function(name?:string) {
    if (name) {
      this.__state.name = name;
    }
    this.emitChange();
  },

  /**
   * @param {string} [version]
   * @private
   */
  __setVersion: function(version?:string) {
    if (version) {
      this.__state.version = version;
    }
    this.emitChange();
  },
};
